export default function Middleware(Module, Operation, Data, Err) {
    try {
        let response = {
            statusCode: 200,
            data: [],
            message: "Success",
            Module: Module
        };


        switch (Operation) {
            case "create":
                response = createOperation(response, Module, Data, Err);
                break;
            case "update":
                response = updateOperation(response, Module, Data, Err);
                break;
            case "delete":
                response = deleteOperation(response, Module, Data);
                break;
            case "fetch":
                response = fetchOperation(response, Module, Data, Err);
                break;
            default:
                response.statusCode = 400;
                response.message = "Invalid operation";
                break;
        }
        console.log(response, "kkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkk",Data,Err)
        return response;

    } catch (error) {
        console.error("Error during operation:", error.message);
        return { statusCode: 500, message: "Internal server error", module: Module };
    }
}


function createOperation(response, Module, Data, Err) {
    if (Err !== undefined) {
        response.statusCode = 400;
        response.message = "Create failed due to error";
        response.data = checkIsarray(Data);

    } else if (Data && (Data.status === 201 || Data.status === 200)) {
        response.statusCode = 201;
        response.message = "Create successful";

        if (Data.data.data === undefined) {
            response.data = checkIsarray(Data.data);
        } else {
            response.data = checkIsarray(Data.data.data);
        }
    }
     if (response.data[0]?.statusCode == 409) {
        response.statusCode = 409;
        console.log(response,"responseresponseresponseresponse",response.data[0].statusCode)
    }


    response.Module = Module
    return response;


}

// Function to handle 'update' operation
function updateOperation(response, Module, Data, Err) {
    if (Err !== undefined) {
        response.statusCode = 400;
        response.message = "Update failed due to error";
        response.data = checkIsarray(Data);

    } else if (Data && (Data.status === 200)) {
        response.statusCode = 200;
        response.message = "Update successful";
        if (Data.data.data === undefined) {
            response.data = checkIsarray(Data.data);
        } else {
            response.data = checkIsarray(Data.data.data);
        }
    }

    if (response.statusCode !== 400 && response.data.length === 0) {
        response.statusCode = 204;
        response.message = "Update failed due to invalid data";
    }
    response.Module = Module
    return response;
}


function deleteOperation(response, Module, Data) {

    console.log("Delete operation for module:", Module, "with data:", Data);


    response.statusCode = 200;
    response.message = "Delete successful";
    response.data = {};
    response.Module = Module
    return response;
}


function fetchOperation(response, Module, Data, Err) {

    
    if (Err !== undefined) {
        response.statusCode = 400;
        response.message = "Fetch failed due to error";
        response.data = checkIsarray(Data);
    } else if (Data && Data.status === 200) {
        let customobject = {}
        response.statusCode = 200;
        response.message = "Fetch successful";
        if (Data.data.count !== undefined) {
            response.count = Data.data.count
        }
        if (Data.data.skip !== undefined) {
            response.skip = Data.data.skip
        }
        if (Data.data.totalCount !== undefined) {
            response.totalCount = Data.data.totalCount
        }

        if (Data.data.take !== undefined) {
            response.take = Data.data.take
        }


        if (Data.data.system_config !== undefined||Data.data.dispo_arr !== undefined || Data.data.Teaminfo !== undefined || Data.data.did_no !== undefined || Data.data.queue !== undefined || Data.data.pause_code !== undefined) {


            if (Data.data.dispo_arr !== undefined) {
                customobject.dispo_arr = Data.data.dispo_arr

            }
            if (Data.data.Teaminfo !== undefined) {
                customobject.Teaminfo = Data.data.Teaminfo

            }
            if (Data.data.system_config !== undefined) {
                customobject.system_config = Data.data.system_config

            }
            if (Data.data.did_no !== undefined) {
                customobject.did_no = Data.data.did_no

            }
            if (Data.data.queue !== undefined) {
                customobject.queue = Data.data.queue

            }
            if (Data.data.pause_code !== undefined) {
                customobject.pause_code = Data.data.pause_code

            }
            if (Object.keys(customobject).length > 0) {
                response.data = checkIsarray({
                    value: Data.data.data,
                    ...customobject
                }
                )
            }
        }else if (Array.isArray(Data.data)) {
            response.data = checkIsarray(Data.data);
        } else if (Data.data.data === undefined) {
            if (Data.data.statusCode === 204) {
                response.data = [];
            } else {
                response.data = checkIsarray(Data.data);
            }

        } else {
            response.data = checkIsarray(Data.data.data);
        }

    } else {
        response.statusCode = 204;
        response.message = "Fetch successful";
        response.data = [];
      
    }
    response.Module = Module
    if (response.statusCode !== 400 && response.data.length === 0) {
        response.statusCode = 204;
    }
    if (response.data[0]?.statusCode === 403) {
        response.statusCode = 403;
    }
    else if (response.data[0]?.statusCode === 409) {
        response.statusCode = 409;
    } else if (typeof response.data[0]==="string") {
        response.statusCode = 204;
        response.message = "Fetch successful";
        response.data = [];
    }

 
    return response;
}

function checkIsarray(value) {

    if (Array.isArray(value)) {
        return value
    } else {
        return [value]
    }


}
